import axios from "axios";
import store from "@/store";


export default function createHttp(secured = true, customToken = null) {

  if (secured) {
    if (customToken) {
      return axios.create({
        headers: { "Authorization": `${customToken}` }
      });
    }
    
    return axios.create({
      headers: { "Authorization": `Bearer ${store.state.token}` }
    });
  } else {
    return axios.create({ headers: {} });
  }
} 